import { render } from "./TheUserInsolvent.vue?vue&type=template&id=1dfb827d"
import script from "./TheUserInsolvent.vue?vue&type=script&lang=js"
export * from "./TheUserInsolvent.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__